var path = '/app/account/password/password-strength-bar.html';
var html = "<div id=strength> <small data-translate>validation.strength</small> <ul id=strengthBar> <li class=point></li> <li class=point></li> <li class=point></li> <li class=point></li> <li class=point></li> </ul> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;